'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Checkbox = require('../../01.atoms/Checkbox/Checkbox.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Form = require('../Form/Form.js');
var Modal = require('../Modal/Modal.js');
var cookies = require('../../../utils/cookies.js');
require('./_index.scss.js');

/*************
 * ClassNames
 *************/

var CLASSNAME = 'varta-cookie-layer';
var cnButton = "".concat(CLASSNAME, "__button");
var cnLink = "".concat(CLASSNAME, "__link");
var cnButtonClose = "".concat(CLASSNAME, "__button-close");
var cnModal = "".concat(CLASSNAME, "__modal");
var cnModalContent = "".concat(CLASSNAME, "__modal-content");
var cnRow = "".concat(CLASSNAME, "__row");
var cnCol = "".concat(CLASSNAME, "__col");
var cnTitle = "".concat(CLASSNAME, "__title");
var cnDescription = "".concat(CLASSNAME, "__description");
var cnModalButtons = "".concat(cnModal, "__buttons");
var cnModalButton = "".concat(cnModal, "__button");
/**
 * 
 */

/**
 * 
 */

var CookieLayer = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(CookieLayer, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(CookieLayer);

  function CookieLayer() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, CookieLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      show: true
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onCookieAccept", function (formData) {
      _this.setState({
        open: false
      });

      _this.onClick(formData['cookies[]']);
    });

    if (typeof document !== 'undefined') {
      _this.state = {
        show: !cookies.readCookie(cookies.layerCookieName)
      };
    }

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(CookieLayer, [{
    key: "onClick",
    value: function onClick() {
      var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [cookies.PERMISSIONS.required];
      var onConfirm = this.props.onConfirm;
      cookies.createCookie(cookies.layerCookieName, permissions.join(','), permissions.length > 1 ? 365 : 31);
      this.setState({
        show: false
      });
      onConfirm(permissions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          message = _this$props.message,
          headline = _this$props.headline,
          className = _this$props.className,
          i18n = _this$props.i18n,
          alwaysShow = _this$props.alwaysShow,
          _this$state = this.state,
          show = _this$state.show,
          open = _this$state.open;

      if (!show && !alwaysShow) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("b", null, headline)), /*#__PURE__*/React__default.createElement(RichText, {
        content: message
      })), /*#__PURE__*/React__default.createElement(ButtonLink, {
        bold: true,
        underline: true,
        style: "light",
        className: cnLink,
        title: i18n.settings,
        onClick: function onClick() {
          return _this2.setState({
            open: true
          });
        }
      }), /*#__PURE__*/React__default.createElement(ButtonPlain, {
        type: "secondary",
        className: cnButton,
        title: i18n.accept,
        onClick: function onClick() {
          return _this2.onClick(Object.keys(cookies.PERMISSIONS).map(function (a) {
            return cookies.PERMISSIONS[a];
          }));
        }
      }), /*#__PURE__*/React__default.createElement(ButtonLink, {
        type: "secondary",
        style: "light",
        className: classNames(cnButtonClose, cnLink),
        iconLeft: "cancel-light",
        onClick: function onClick() {
          return _this2.onClick();
        }
      }), /*#__PURE__*/React__default.createElement(Modal, {
        open: open,
        showCloseButton: true,
        title: i18n.titleModal,
        className: cnModal,
        classNameContent: cnModalContent,
        zIndex: 1400,
        onClose: function onClose() {
          return _this2.setState({
            open: false
          });
        }
      }, /*#__PURE__*/React__default.createElement("p", null, i18n.contentModal), /*#__PURE__*/React__default.createElement(Form, {
        onSubmitSuccess: this.onCookieAccept
      }, /*#__PURE__*/React__default.createElement("label", {
        className: cnRow
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        value: cookies.PERMISSIONS.required,
        name: "cookies[]",
        checked: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement("p", {
        className: cnTitle
      }, /*#__PURE__*/React__default.createElement("b", null, i18n.requiredTitle)), /*#__PURE__*/React__default.createElement("p", {
        className: cnDescription
      }, i18n.requiredBody))), /*#__PURE__*/React__default.createElement("label", {
        className: cnRow
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        value: cookies.PERMISSIONS.analytics,
        name: "cookies[]"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement("p", {
        className: cnTitle
      }, /*#__PURE__*/React__default.createElement("b", null, i18n.analyticsTitle)), /*#__PURE__*/React__default.createElement("p", {
        className: cnDescription
      }, i18n.analyticsBody))), /*#__PURE__*/React__default.createElement("label", {
        className: cnRow
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        value: cookies.PERMISSIONS.marketing,
        name: "cookies[]"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnCol
      }, /*#__PURE__*/React__default.createElement("p", {
        className: cnTitle
      }, /*#__PURE__*/React__default.createElement("b", null, i18n.marketingTitle)), /*#__PURE__*/React__default.createElement("p", {
        className: cnDescription
      }, i18n.marketingBody))), /*#__PURE__*/React__default.createElement("div", {
        className: cnModalButtons
      }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnModalButton,
        title: i18n.save,
        submit: true
      }), /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnModalButton,
        title: i18n.accept,
        onClick: function onClick() {
          return _this2.onClick(Object.keys(cookies.PERMISSIONS).map(function (a) {
            return cookies.PERMISSIONS[a];
          }));
        },
        type: "secondary"
      })))));
    }
  }]);

  return CookieLayer;
}(React__default.Component);
CookieLayer.propTypes = {
  /** Additional class name */
  className: PropTypes.string,
  headline: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  i18n: PropTypes.shape().isRequired,
  alwaysShow: PropTypes.bool
};
CookieLayer.defaultProps = {
  i18n: {},
  onConfirm: function onConfirm() {
    return void 0;
  }
};

module.exports = CookieLayer;
